import { EMPLOYMENTS } from '@config/constants';
import { useMemo } from 'react';
import { useGetDocumentsInfoQuery } from '../graphql';
import { useParseDocumentInfo } from './useParseDocumentInfo';
import { DOCUMENT_KEYS } from '../components';

export const useController = () => {
  const { data, loading: isLoading } = useGetDocumentsInfoQuery();
  const { parseDocByKlass, parseDocByType } = useParseDocumentInfo();

  const employmentId = data?.activeRequisition?.income?.employment.id || '';
  const hasTaxSituation = data?.activeRequisition?.income?.hasTaxSituation || '';
  const isEmployee = employmentId === EMPLOYMENTS.EMPLOYEE;
  const isBusinessOwner = employmentId === EMPLOYMENTS.OWNER;
  const selfEmployee = employmentId === EMPLOYMENTS.SELF_EMPLOYEE;

  const showTaxSituation = selfEmployee && hasTaxSituation;

  const documents = useMemo(() => data?.activeRequisition?.documents || [], [data]);
  const requisitionStatus = data?.activeRequisition?.status || '';
  const paymentFrequency = useMemo(() => data?.activeRequisition?.income?.paymentFrequency || '', [data]);

  const docsData = useMemo(() => ({
    proofOfIncome: parseDocByKlass({
      documents,
      klass: DOCUMENT_KEYS.PROOF_OF_INCOME,
      paymentFrequency,
      requisitionStatus,
    }),
    identification: parseDocByKlass({
      documents,
      klass: DOCUMENT_KEYS.OFFICIAL_ID,
      requisitionStatus,
    }),
    proofOfAddress: parseDocByKlass({
      documents,
      klass: DOCUMENT_KEYS.PROOF_OF_ADDRESS,
      requisitionStatus,
    }),
    proofOfActivity: parseDocByKlass({
      documents,
      klass: DOCUMENT_KEYS.PROOF_OF_ACTIVITY,
      requisitionStatus,
    }),
    taxSituation: parseDocByType({
      documents,
      type: DOCUMENT_KEYS.TAX_SITUATION,
      requisitionStatus,
    }),
    bankStatement: parseDocByType({
      documents,
      notPreferred: true,
      type: DOCUMENT_KEYS.BANK_STATEMENT,
      requisitionStatus,
    }),
  }), [
    documents,
    parseDocByType,
    parseDocByKlass,
    paymentFrequency,
    requisitionStatus,
  ]);

  return {
    isLoading,
    isEmployee,
    isBusinessOwner,
    showTaxSituation,
    ...docsData,
  };
};
